module.exports = __webpack_public_path__ + "img/besler.50245345.jpg";